import React, { useState } from 'react';
import LoadSimple from '../LoadSimple';
import AccionesList from './AccionesList';
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
const TableAcciones = ({startLimit,pageActual,limitList, languaje,mode,cisSelected,setCisSelected,registerIsValid,searchResults, setSearchResults,onSearch,dataUsers,setDataUsers,searchTerm, setSearchTerm,server,setRegisterIsValid,setData,setLoading,setError,handleChangEdit }) => {
  
  return (
    <div className="cont-table-portafolio">
                                    <div className={"head-table-portafolio"+mode}>
                                    <div className="compact-head-table-portafolio">
                                        <div className='field-head-table-accManage field-larger' style={{borderLeft: '1px solid rgba(240, 248, 255, 0.473)' }}>
                                            ID 
                                        </div>
                                        <div className='field-head-table-accManage field-x-larger'>
                                        {capitalizeFirstLetter(lang[languaje]['nombre'])}
                                        </div>
                                        <div className='field-head-table-accManage field-larger'>
                                           HOSTS {capitalizeFirstLetter(lang[languaje]['aplicados'])}
                                        </div>
                                        <div className='field-head-table-accManage field-larger'>
                                            STATUS
                                        </div>
                                        <div className='field-head-table-accManage field-larger'>
                                        {capitalizeFirstLetter(lang[languaje]['acciones'])}
                                        </div>
                                      </div>
                                        
                                       
                                       
                                        
                                    </div>
                                    <div className='body-table-cis-gs'>
                                      {
                                            ( registerIsValid)?<div className='cont-load-user-list'><LoadSimple></LoadSimple></div>:
                                            <AccionesList startLimit={startLimit} pageActual={pageActual} limitList={limitList} languaje={languaje} mode={mode} cisSelected={cisSelected} setCisSelected={setCisSelected} searchResults={searchResults} setSearchResults={setSearchResults} searchTerm={searchTerm} setSearchTerm={setSearchTerm} dataUsers={dataUsers} setDataUsers={setDataUsers} server={server} setRegisterIsValid={setRegisterIsValid} setData={setData} setLoading={setLoading} setError={setError}  handleChangEdit={handleChangEdit}/>
                                        
                                          }
                                        
                                        
                                    </div>
                                </div>
  );
}

export default TableAcciones;
